// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types.js';
import { validateEnv } from '../../lib/envValidation.js';

const SUPABASE_URL = (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL) ||
  (typeof window !== 'undefined' ? (import.meta as any).env?.VITE_SUPABASE_URL : undefined);
const SUPABASE_PUBLISHABLE_KEY = (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_PUBLISHABLE_KEY) ||
  (typeof window !== 'undefined' ? (import.meta as any).env?.VITE_SUPABASE_PUBLISHABLE_KEY : undefined);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const envValidation = validateEnv();
export const isSupabaseConfigured = envValidation.ok && !!(SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY);

if (!isSupabaseConfigured) {
  console.warn(
    `[envValidation] Missing required env vars: ${envValidation.missingRequired.join(', ') || '(none — supabase client init still failed)'}. ` +
      `App will render MaintenanceScreen. See .env.template.`
  );
}
if (envValidation.missingOptional.length > 0) {
  console.info(
    `[envValidation] Optional env vars not set (related features disabled): ${envValidation.missingOptional.join(', ')}.`
  );
}

export const supabase = isSupabaseConfigured
  ? createClient<Database>(SUPABASE_URL!, SUPABASE_PUBLISHABLE_KEY!, {
      auth: {
        storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
        persistSession: typeof localStorage !== 'undefined',
        autoRefreshToken: typeof localStorage !== 'undefined',
      }
    })
  : null as unknown as ReturnType<typeof createClient<Database>>;
